import styled from 'styled-components'

export const Container = styled.div`
	padding: 16px 32px 16px 16px;
	overflow: auto;
	height: 100%;
	box-sizing: border-box;
`
